export class QueryField {
  entity: string;
  field: string;
}
